import { useState } from "react";
import type { Swiper } from "swiper";

export const useColorVariationCarouselSwiper = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState<Swiper | null>(null);

  return {
    thumbsSwiper,
    setThumbsSwiper,
  };
};
